import { checkIsOutStock } from '../../../../utils/useCheckIsOutStock';
import Button from '../../../atoms/button/Button';
import { Drawer } from '../../../molecules/drawer/Drawer';
import IconButton from '../../../atoms/iconButton/IconButton';
import SvgCartTick from '../../../atoms/icons/CartTick';
import PromoMessage from '../../../atoms/promoMessage/PromoMessage';
import { Text } from '../../../typography/text/Text';
import styles from './MobileMinicart.module.scss';
import app from '@frontastic/catwalk/src/js/app/app';
import PropTypes from 'prop-types';
import React from 'react';
import Price from '../../../molecules/price/Price';
import { checkGiftCardPurchase } from '../../../../utils/checkGiftCardPurchase';

const MobileMinicartConfirmation = React.forwardRef(
  ({ data, showDialog, setShowDialog, promotionText }, ref) => {
    const { isGiftCardPurchase } = checkGiftCardPurchase();
    const isLocked = data.lineItems && checkIsOutStock(data.lineItems) && !isGiftCardPurchase;
    const noProductsMessage = 'Add items to proceed to checkout';
    const subTotal = data?.projectSpecificData?.subTotal

    return (
      <div id="mobile-minicart-confirmation" ref={ref}>
        {showDialog && (
          <Drawer
            onClose={() => {
              setTimeout(() => setShowDialog(false), 500);
            }}
            shown={showDialog}
            showHeader={false}
            position="top"
            indent="84"
            customClasses={{
              aside: styles.aside,
              header: styles.header,
            }}
          >
            <div className={styles.wrapper} ref={ref}>
              <div className={styles.orderContent}>
                <div className={styles.orderDetails}>
                  {subTotal && (
                    <div className={styles.orderSubtotal}>
                      <Text
                        as="span"
                        textTransform="firstletter"
                        align="start"
                        className={styles.subtotalPrice}
                      >
                        Bag Subtotal
                      </Text>
                      <Price value={subTotal} />
                    </div>
                  )}
                  <div className={styles.iconAndSuccessBlock}>
                    <div className={styles.iconBlock}>
                      <IconButton
                        color="primary"
                        iconRegular={() => (
                          <SvgCartTick width="20" height="20" />
                        )}
                        iconHover={() => <SvgCartTick width="20" height="20" />}
                        iconActive={() => (
                          <SvgCartTick width="20" height="20" />
                        )}
                      />
                    </div>
                    <div className={styles.successBlock}>
                      <Text textTransform="firstletter" align="start">
                        {data.lineItems?.length > 0
                          ? `${data.lineItems[data.lineItems.length - 1].name}`
                          : `cart is empty`}
                      </Text>
                      <Text
                        as="span"
                        size="xxs"
                        weight="light"
                        textTransform="firstletter"
                        align="start"
                        className={styles.addedSuccessfully}
                      >
                        {data.lineItems?.length > 0
                          ? `Successfully added to your bag`
                          : `you need to choose something`}
                      </Text>
                    </div>
                  </div>
                  {promotionText && (
                    <div className={styles.promoMesageBlock}>
                      <PromoMessage
                        promotionColour="red"
                        text={promotionText}
                      />
                    </div>
                  )}
                </div>
              </div>
              {!data.lineItems?.length && noProductsMessage && (
                <div className={styles.noProductsMessage}>
                  <Text
                    as="span"
                    size="xs"
                    weight="normal"
                    textTransform="none"
                    align="center"
                  >
                    {noProductsMessage}
                  </Text>
                </div>
              )}
              <div className={styles.buttons}>
                <Button
                  variant="primary"
                  shape="square"
                  isOutlined={false}
                  isInverted={false}
                  submit={true}
                  as="button"
                  disabled={isLocked}
                  data-cart-button="proceed_to_cart"
                  onClick={() => {
                    setShowDialog(false);
                    app
                      .getRouter()
                      .push('Frontastic.Frontend.Master.Checkout.cart');
                  }}
                  className={styles.procedButton}
                >
                  <Button.Label>PROCEED TO CART</Button.Label>
                </Button>
                <Button
                  variant="secondaryOutlined"
                  shape="square"
                  isOutlined={false}
                  isInverted={true}
                  data-cart-button="continue_shopping"
                  as="button"
                  onClick={() => setShowDialog(false)}
                  className={styles.continueButton}
                >
                  <Button.Label>CONTINUE SHOPPING</Button.Label>
                </Button>
              </div>
            </div>
          </Drawer>
        )}
      </div>
    );
  },
);

MobileMinicartConfirmation.propTypes = {
  subtotalPrice: PropTypes.number,
  productName: PropTypes.string,
  promoMessage: PropTypes.string,
};

MobileMinicartConfirmation.defaultProps = {
  subtotalPrice: 0,
  productName: '',
  promoMessage: '',
};

export default MobileMinicartConfirmation;
